import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { APIRequestResources, ApiService, APIResponse, PaginationResponse } from '../core';
import { BuyerData, BuyerDetailsDTO, BuyerDTO, UpdateBuyer } from '../interfaces';
import { handleError } from '../core/util/util';

@Injectable({
  providedIn: 'root'
})
export class BuyerService {
  private readonly apiService = inject(ApiService);
  private readonly router = inject(Router);

  private readonly $all = new BehaviorSubject<BuyerData[]>([]);
  all = toSignal(this.$all, {initialValue: []});

  private readonly $active = new BehaviorSubject<BuyerDetailsDTO | undefined>(undefined);
  active = toSignal(this.$active, {initialValue: undefined});

  constructor() {}

  find(params: any, refresh = true) {
    return this.apiService.GET<PaginationResponse<BuyerData[]>>(
        APIRequestResources.BuyerService,
        {
          endpoint: `search`,
          params: params
        }
    ).pipe(
        tap(res => this.$all.next(res.data.data ?? [])),
        catchError(handleError)
    );
  }

  getById = (id: string, refresh = false) => {
    return this.apiService.GET<BuyerDetailsDTO>(
        APIRequestResources.BuyerService,
        {
          endpoint: `${id}`
        }
    ).pipe(
        tap((res) => this.$active.next(res.data)),
        catchError(handleError)
    );
  }

  update = (id: string, buyer: UpdateBuyer) => {
    return this.apiService.PATCH<BuyerDTO>(
        APIRequestResources.BuyerService,
        buyer,
        {
          endpoint: `${id}`
        }
    ).pipe(
        tap(() => this.getById(id))
    );
  }


    searchBuyers(params: any, refresh = true) {
        return this.apiService.GET<PaginationResponse<BuyerData[]>>(
            APIRequestResources.BuyerService,
            {
                endpoint: `search`,
                params: params
            }
        ).pipe(
            tap(res => {
                // Ensure the data is an array and update the $all BehaviorSubject
                const buyers = Array.isArray(res.data) ? res.data : [];
                console.log(buyers)
                this.$all.next(buyers);
            }),
            catchError(handleError)
        );
    }

  initial = () => {
    this.$active.next(undefined);
  }
}